import React from 'react'

export default function VINHeader() {
    return (
        <div className='dispatch-vin-header'>
            <div className='dispatch-vin-tab'>
                <div className='dispatch-vin-count'>450</div> All VINs
            </div>
            <div className='dispatch-vin-search'>
                <input id="vin-search" type="search" placeholder="" />
            </div>
        </div>
    )
}
